import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { toastState } from "../../recoil/toast/toastState";
import styles from "./Toast.module.css";
import { CloseIcon } from "../../icons";
import { ToastIcon } from "./ToastIcon";
import * as ToastRadix from "@radix-ui/react-toast";

const DISPLAY_DURATION = 3000;

const Toast = () => {
  const [toast, setToast] = useRecoilState(toastState);
  const timerRef = React.useRef(0);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const handleClose = () => {
    setToast((prev) => ({ ...prev, isVisible: false }));
  };

  // toast.isVisible이 false거나 toast.message가 없으면 렌더링하지 않음
  if (!toast.isVisible || !toast.message) return null;

  return (
    <ToastRadix.Provider swipeDirection="up">
      <ToastRadix.Root
        className={styles.Root}
        open={toast.isVisible}
        onOpenChange={(open) => {
          if (!open) handleClose();
        }}
        duration={DISPLAY_DURATION}
      >
        {toast.type && <ToastIcon type={toast.type} />}
        <ToastRadix.Title className={styles.Title}>{toast.message}</ToastRadix.Title>

        <ToastRadix.Action
          className={styles.Action}
          asChild
          altText="Close notification"
        >
          <CloseIcon
            w={6}
            h={6}
            color="rgba(124, 129, 131, 1)"
            onClick={handleClose}
            onMouseDown={(e) => e.stopPropagation()}
            aria-label="Close notification"
            padding={1}
            borderRadius={"4px"}
            cursor={"pointer"}
            _hover={{
              background: "rgba(255, 255, 255, 0.08)",
              color: "#fff",
            }}
          />
        </ToastRadix.Action>
      </ToastRadix.Root>
      <ToastRadix.Viewport className={styles.Viewport} />
    </ToastRadix.Provider>
  );
};

export default React.memo(Toast);
